class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainImg = this.querySelector('.product-gallery__main-img');
    this.thumbs = this.querySelectorAll('.product-gallery__thumb');

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.setImage(thumb));
    });
  }

  setImage(thumb) {
    if (this.mainImg) {
      this.mainImg.src = thumb.dataset.full || thumb.src;
      if (thumb.dataset.srcset) {
        this.mainImg.srcset = thumb.dataset.srcset;
      }
    }
    this.thumbs.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.idInput = this.querySelector('input[name="id"]');
    this.priceEl = this.querySelector('.product-sidebar__price');
    this.submitBtn = this.querySelector('.product-sidebar__atc');
    this.stickyBtn = document.querySelector('.sticky-cta__btn');
    this.stickyIdInput = document.querySelector('.js-sticky-variant-id');
    this.variantData = [];

    try {
      this.variantData = JSON.parse(this.dataset.variants || '[]');
    } catch (e) {}

    this.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => this.onVariantChange());
    });

    this.querySelectorAll('.variant-option__select').forEach(select => {
      select.addEventListener('change', () => this.onVariantChange());
    });

    const sfToggle = this.querySelector('.js-sf-toggle');
    const sfPanel = this.querySelector('.js-sf-panel');
    if (sfToggle && sfPanel) {
      sfToggle.addEventListener('click', () => {
        const expanded = sfToggle.getAttribute('aria-expanded') === 'true';
        sfToggle.setAttribute('aria-expanded', String(!expanded));
        if (expanded) sfPanel.setAttribute('hidden', '');
        else sfPanel.removeAttribute('hidden');
      });
      new SizeRecommender(sfPanel, this);
    }
  }

  getSelectedOptions() {
    const selected = {};
    this.querySelectorAll('.variant-picker').forEach(picker => {
      const checked = picker.querySelector('input[type="radio"]:checked');
      const dropdown = picker.querySelector('.variant-option__select');
      if (checked) {
        selected[picker.dataset.option] = checked.value;
      } else if (dropdown) {
        selected[picker.dataset.option] = dropdown.value;
      }
    });
    return selected;
  }

  onVariantChange() {
    const selected = this.getSelectedOptions();
    const optionCount = Object.keys(selected).length;

    const variant = this.variantData.find(v => {
      return v.options.every((opt, i) => selected[`option${i + 1}`] === opt);
    });

    if (!variant) return;

    if (this.idInput) {
      this.idInput.value = variant.id;
    }

    if (this.priceEl) {
      const priceEl = this.priceEl.querySelector('.product-price__current');
      if (priceEl && variant.price !== undefined) {
        const formatted = (variant.price / 100).toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR'
        });
        priceEl.textContent = formatted;
      }

      const compareEl = this.priceEl.querySelector('.product-price__compare');
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          const formattedCompare = (variant.compare_at_price / 100).toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR'
          });
          compareEl.textContent = formattedCompare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    if (this.submitBtn) {
      if (variant.available) {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'In den Warenkorb';
      } else {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Ausverkauft';
      }
    }

    // Sync sticky CTA
    if (this.stickyIdInput) this.stickyIdInput.value = variant.id;
    if (this.stickyBtn) {
      this.stickyBtn.disabled = !variant.available;
      this.stickyBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }

    // Update sticky price
    const stickyPrice = document.querySelector('.sticky-cta__price');
    if (stickyPrice && variant.price !== undefined) {
      stickyPrice.textContent = (variant.price / 100).toLocaleString('de-DE', {
        style: 'currency', currency: 'EUR'
      });
    }

    // Update URL without page reload
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }
}

class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.btns = this.querySelectorAll('.product-tabs__btn');
    this.panels = this.querySelectorAll('.product-tabs__panel');

    this.btns.forEach((btn, i) => {
      btn.addEventListener('click', () => this.show(i));
    });
  }

  show(index) {
    this.btns.forEach((b, i) => {
      b.classList.toggle('is-active', i === index);
      b.setAttribute('aria-selected', String(i === index));
    });
    this.panels.forEach((p, i) => {
      p.classList.toggle('is-active', i === index);
    });
  }
}

// Quantity selector
document.querySelectorAll('.js-qty-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.closest('.product-quantity__wrapper').querySelector('.product-quantity__input');
    if (!input) return;
    const current = parseInt(input.value) || 1;
    if (btn.dataset.action === 'increase') {
      input.value = current + 1;
    } else if (btn.dataset.action === 'decrease' && current > 1) {
      input.value = current - 1;
    }
  });
});

// Sticky Mobile CTA — IntersectionObserver
const atcBtn = document.getElementById('product-atc-{{ section.id }}') || document.querySelector('.product-sidebar__atc');
const stickyCta = document.getElementById('sticky-cta');

if (atcBtn && stickyCta) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        stickyCta.classList.add('is-visible');
        stickyCta.setAttribute('aria-hidden', 'false');
      } else {
        stickyCta.classList.remove('is-visible');
        stickyCta.setAttribute('aria-hidden', 'true');
      }
    },
    { threshold: 0, rootMargin: '0px 0px -100px 0px' }
  );
  observer.observe(atcBtn);
}

class SizeRecommender {
  constructor(panel, form) {
    this.panel = panel;
    this.form = form;
    this.bodyAdj = 0;
    this.init();
  }

  init() {
    this.panel.querySelectorAll('.sf-body-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        this.panel.querySelectorAll('.sf-body-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.bodyAdj = parseInt(btn.dataset.body) || 0;
      });
    });

    const calcBtn = this.panel.querySelector('.js-sf-calc');
    if (calcBtn) calcBtn.addEventListener('click', () => this.calculate());

    this.panel.querySelectorAll('.js-sf-height, .js-sf-weight').forEach(input => {
      input.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); this.calculate(); }
      });
    });
  }

  calculate() {
    const height = parseInt(this.panel.querySelector('.js-sf-height')?.value) || 0;
    const weight = parseInt(this.panel.querySelector('.js-sf-weight')?.value) || 0;
    const resultEl = this.panel.querySelector('.js-sf-result');
    if (!resultEl) return;

    if (!height || !weight || height < 140 || height > 220 || weight < 40 || weight > 180) {
      resultEl.innerHTML = '<p class="size-finder__result-text size-finder__result--error">Bitte Körpergröße (140–220 cm) und Gewicht (40–180 kg) eingeben.</p>';
      return;
    }

    const productType = (this.form.dataset.productType || '').toLowerCase();
    const isPolo = productType.includes('polo');
    const isHemd = productType.includes('hemd');

    const sizes = ['S', 'M', 'L', 'XL'];

    let baseIdx;
    if (isPolo || isHemd) {
      // L ab 183 cm (kürzer geschnitten bei Polo, schlank bei Hemd)
      if (height < 170)      baseIdx = 0;
      else if (height < 183) baseIdx = 1;
      else if (height < 192) baseIdx = 2;
      else                   baseIdx = 3;
    } else {
      if (height < 169)      baseIdx = 0;
      else if (height < 181) baseIdx = 1;
      else if (height < 191) baseIdx = 2;
      else                   baseIdx = 3;
    }

    let weightAdj = 0;
    if (isPolo || isHemd) {
      if (weight < 62)       weightAdj = -1;
      else if (weight > 105) weightAdj = 2;
      else if (weight > 89)  weightAdj = 1;
    } else {
      if (weight < 64)       weightAdj = -1;
      else if (weight > 108) weightAdj = 2;
      else if (weight > 92)  weightAdj = 1;
    }

    const idx = Math.max(0, Math.min(sizes.length - 1, baseIdx + weightAdj + this.bodyAdj));
    const size = sizes[idx];

    let hint;
    if (isPolo)      hint = 'Kürzer geschnitten – im Zweifelsfall eine Größe größer wählen.';
    else if (isHemd) hint = 'Fällt etwas kleiner aus – im Zweifelsfall eine Größe größer wählen.';
    else             hint = 'Fällt regular aus.';

    resultEl.innerHTML = `<p class="size-finder__result-text">Wir empfehlen dir <strong class="size-finder__result-size">${size}</strong><span class="size-finder__result-hint">${hint}</span></p>`;

    this.selectSize(size);
  }

  selectSize(size) {
    this.form.querySelectorAll('.variant-picker').forEach(picker => {
      const labelEl = picker.querySelector('.variant-picker__label');
      if (!labelEl) return;
      const labelText = labelEl.textContent.toLowerCase();
      if (!labelText.includes('größe') && !labelText.includes('size')) return;
      picker.querySelectorAll('input[type="radio"]').forEach(radio => {
        if (radio.value.toUpperCase() === size.toUpperCase()) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }
}

const definitions = [
  ['product-gallery', ProductGallery],
  ['product-form', ProductForm],
  ['product-tabs', ProductTabs],
];

definitions.forEach(([name, cls]) => {
  if (!customElements.get(name)) customElements.define(name, cls);
});
